import { registerPlugin } from '@capacitor/core';

export type NavigationInfo = {
    mode: 'gestures' | 'buttons' | 'unknown';
    navBarHeightPx: number;
    navBarHeightRawPx: number;
    sdkInt: number;
    cameraCutoutTopPx?: number;
    cameraCutoutTopRawPx?: number;
};

export interface SystemUiPlugin {
    getNavigationInfo(): Promise<NavigationInfo>;
}

export const SystemUi = registerPlugin<SystemUiPlugin>('SystemUi');


